import React from "react";
import { ArrowRight, HardHat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSrdStandard() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll();
  return <section data-section-id="18990" id="heavy-duty-reliability-for-your-job-site" className="dark bg-background text-foreground relative min-h-[90vh] w-full overflow-hidden lg:grid lg:grid-cols-2 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/substation_poster.png')] bg-cover bg-center">
  {}
  <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/20" />

  {}
  <div className="relative z-10 flex flex-col justify-center px-6 py-20 lg:col-start-1 lg:px-16 lg:py-0 xl:px-24">
    
    {}
    <div className="text-primary/10 font-mono absolute -top-10 -left-4 -z-10 select-none text-[12rem] font-bold leading-none tracking-tighter lg:-left-12 lg:top-1/4 lg:text-[20rem]" aria-hidden="true">
      RENT
    </div>

    {}
    <div ref={contentRef} className={`transition-all duration-1000 ease-out ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
      <h1 className="font-sans text-5xl font-black leading-[0.9] tracking-tighter text-white sm:text-6xl md:text-7xl lg:text-8xl uppercase">
        SURFACE <br />
        <span className="text-primary">GRADING</span> <br />
        <span className="font-normal text-muted-foreground">
          & EQUIPMENT <br />
          RENTALS.
        </span>
      </h1>

      <p className="text-muted-foreground mt-8 max-w-lg text-lg font-medium md:text-xl">
        Mastering the terrain with advanced laser-guided technology, 
        premium equipment rentals, and heavy-duty grading solutions. 
        We deliver perfectly leveled foundations and optimized site 
        drainage for industrial-scale projects.
      </p>

      <div className="mt-10 flex flex-col gap-4 sm:flex-row">
        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 rounded-sm px-8 text-base font-bold uppercase tracking-wide shadow-xl shadow-orange-950/40">
          <Link to="/BookNowPage">
            Book Now
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </Button>

        <Button asChild variant="outline" size="lg" className="border-primary/40 text-foreground hover:bg-primary/10 hover:text-primary h-14 rounded-sm px-8 text-base font-bold uppercase tracking-wide backdrop-blur-md">
          <Link to="/EquipmentPage">
            <HardHat className="mr-2 h-5 w-5" />
            View Equipment
          </Link>
        </Button>
      </div>
    </div>
  </div>
</section>;
}